import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import { useNavigate, Link } from "react-router-dom";
import { getAllcustomers, selectAllInvoices, selectInvoicesPager, updateInvoicesSearch } from "../redux/slices/publicSlice";
import { getMe, selectMe } from "../redux/slices/generalSlice";
import moment from "moment";
import { formatTime } from "../utils/formatTime";
import { Helmet } from "react-helmet-async";
import { useRef } from "react";
import Loader from "../components/Loader";
import { Modal, Button, Form } from 'react-bootstrap';
import { backendServerBaseURL, backendServerBaseURL2 } from "../utils/backendServerBaseURL";

const Customers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allInvoices = useSelector(selectAllInvoices);
  const pager = useSelector(selectInvoicesPager);
  const [loading, setloading] = useState(true);
  const searchRef = useRef(null);
  const [search, setSearch] = useState("");
  const [sortType, setSortType] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
const [notification, setNotification] = useState(null);
const [apiError, setApiError] = useState(null);
const [activeCategory, setActiveCategory] = useState('residential');
const me = useSelector(selectMe);

useEffect(() => {
  dispatch(getMe());
}, []);



  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleModalOpen = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const onSearchChangeHandler = useCallback(
    debounce((searchValue) => {
      if (searchValue === "") {
        dispatch(updateInvoicesSearch(""));
        dispatch(getAllcustomers({ page: pager.page, sortType, setloading }));
      } else {
        dispatch(updateInvoicesSearch(searchValue));
        dispatch(getAllcustomers({ page: pager.page, sortType, setloading }));
      }
    }, 250),
    [sortType, setloading]
  );

  useEffect(() => {
    setloading(true);
    dispatch(getAllcustomers({ page: 1, sortType, setloading }));
  }, [sortType]);

  useEffect(() => {
    setSearch("");
    dispatch(updateInvoicesSearch(""));
  }, []);
  

  const valueRef = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
setIsLoading(true);
  setNotification(null);

    let value = valueRef.current.value;
    const action = document.querySelector('input[name="action"]:checked').value;


    let finalAction = action;

  const isPositiveInteger = /^[0-9]+$/;

  const isZeroOrDecimal = /^0*(?:\.\d{1,2})?$/;

  if (action === 'add' && !isPositiveInteger.test(value)) {
    setApiError('Please enter a positive whole number for adding value.');
    setIsLoading(false);
  } else if (action === 'del' && !isZeroOrDecimal.test(value)) {
    setApiError('Please enter zero or a decimal number with up to two decimal places for removing value.');
    setIsLoading(false);
  }
    
    const url = `${backendServerBaseURL2}/${finalAction}/${selectedId}/${value}`;
    try {
      const response = await axios.post(url, null, {
        headers: { 'x-api-key': me?.xApiKey }
      });
      console.log(response.data);

    if (response.status === 200) {
      setNotification('success');
      dispatch(getAllcustomers({ page: pager.page, sortType })).then(() => {
        const updatedInvoice = allInvoices.find(invoice => invoice._id === selectedId);
        if (updatedInvoice) {
          setSelectedId(updatedInvoice._id);
        }
      }).catch(error => {
        console.error('Error updating invoices:', error);
      });
    } else {
      setNotification('error');
    }

      setIsLoading(false);
} catch (error) {
  console.error("An error occurred during the API request:", error);
      setIsLoading(false);
  if (error.response && error.response.data && error.response.data.error) {
    setApiError(error.response.data.error);
  } else {
    setApiError('Something went wrong.');
  }
  setNotification('error');
}
} 


useEffect(() => {
  const selectedInvoice = allInvoices.find(invoice => invoice._id === selectedId);
  if (selectedInvoice && selectedInvoice.type) {
    setActiveCategory(selectedInvoice.type.toLowerCase());
  }
}, [selectedId, allInvoices]);

const handleCategoryClick = (category) => {
  const selectedInvoice = allInvoices.find(invoice => invoice._id === selectedId);
  if (selectedInvoice && selectedInvoice.type.toLowerCase() === category.toLowerCase()) {
    setActiveCategory(category.toLowerCase());
  }
};

const selectedInvoiceType = allInvoices.find(invoice => invoice._id === selectedId)?.type.toLowerCase();

const [actionType, setActionType] = useState('add');
const [ipv4Address, setIpv4Address] = useState('');

const handleActionChange = (e) => {
  setActionType(e.target.value);
};

const handleIpv4Change = (e) => {
  setIpv4Address(e.target.value);
};

const handleSubmit2 = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setNotification(null);

  const url = `${backendServerBaseURL2}/plan/ipv6/${actionType}/whitelist/${selectedId}/${ipv4Address}`;
  try {
    console.log(me?.xApiKey);
    const response = await axios.post(url, null, {
      headers: { 'x-api-key': me?.xApiKey }
    });
    // İstek başarılıysa yapılan işlemler
    setIsLoading(false);
    if (response.status === 200) {
      setNotification('success');
      dispatch(getAllcustomers({ page: pager.page, sortType })).then(() => {
        const updatedInvoice = allInvoices.find(invoice => invoice._id === selectedId);
        if (updatedInvoice) {
          setSelectedId(updatedInvoice._id);
        }
      }).catch(error => {
        console.error('Error updating invoices:', error);
      });
    } else {
      setNotification('error');
    }
  } catch (error) {
    console.error("API request error:", error);
    setIsLoading(false);
    setNotification('error');
    
    const errorMessage = error.response && error.response.data && error.response.data.error
      ? error.response.data.error
      : 'Something went wrong, please try again later.';
    setApiError(errorMessage);
  }
  
};

const handleSubmit3 = async (e) => {
  e.preventDefault();
  setIsLoading2(true);
  setNotification(null);

  const url = `${backendServerBaseURL2}/bwfixed/${selectedId}`;
  try {
    const token = await localStorage.getItem("accessToken", "");
    const response = await axios.post(url, null, {
      headers: { 'x-api-key': me?.xApiKey }
    });

    setIsLoading2(false);
    if (response.status === 200) {
      setNotification('success');
      dispatch(getAllcustomers({ page: pager.page, sortType })).then(() => {
        const updatedInvoice = allInvoices.find(invoice => invoice._id === selectedId);
        if (updatedInvoice) {
          setSelectedId(updatedInvoice._id);
        }
      }).catch(error => {
        console.error('Error updating invoices:', error);
      });
    } else {
      setNotification('error');
    }
  } catch (error) {
    console.error("API request error:", error);
    setIsLoading2(false);
    setNotification('error');
    
    const errorMessage = error.response && error.response.data && error.response.data.error
      ? error.response.data.error
      : 'Something went wrong, please try again later.';
    setApiError(errorMessage);
  }
};

const handleSubmit4 = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setNotification(null);

  const url = `${backendServerBaseURL2}/plan/datacenter/${actionType}/whitelist/${selectedId}/${ipv4Address}`;
  try {
    console.log(me?.xApiKey);
    const response = await axios.post(url, null, {
      headers: { 'x-api-key': me?.xApiKey }
    });
    setIsLoading(false);
    if (response.status === 200) {
      setNotification('success');
      dispatch(getAllcustomers({ page: pager.page, sortType })).then(() => {
        const updatedInvoice = allInvoices.find(invoice => invoice._id === selectedId);
        if (updatedInvoice) {
          setSelectedId(updatedInvoice._id);
        }
      }).catch(error => {
        console.error('Error updating invoices:', error);
      });
    } else {
      setNotification('error');
    }
  } catch (error) {
    console.error("API request error:", error);
    setIsLoading(false);
    setNotification('error');
    
    const errorMessage = error.response && error.response.data && error.response.data.error
      ? error.response.data.error
      : 'Something went wrong, please try again later.';
    setApiError(errorMessage);
  }
  
};

  return (
    <>
      <Helmet>
        <title>Customers - LightningProxies</title>
      </Helmet>

      <div class="page-body-wrapper">
        <div class="row text-start">
          <div class="col-12 col-md-7 col-xl-6">
            <div class="header-title">
              <h1>Customers</h1>
              <p>Detailed list of all invoices</p>
            </div>
          </div>
          <div class="col-12 col-md-5 col-xl-6">
            <div class="header-bttn">
              <p>
                Need Support?{" "}
                <a href="https://t.me/lightningproxies">
                  Contact Us <i class="fa fa-angle-right"></i>
                </a>
              </p>
            </div>
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : allInvoices && allInvoices.length === 0 && search.length === 0 ? (
          <div class="row">
            <div class="col-12">
              <div class="dashboard-empty-box mt-15">
                <img src="./assets/images/no-invoice.svg" alt="Empty Image" class="img-fluid d-light" />
                <img src="./assets/images/no-invoice-dark.svg" alt="Empty Image" class="img-fluid d-dark" />
                <p>
                  No plan{" "}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div class="row">
            <div class="col-12">
              <div class=" active-plan-table mt-15 invoice-list-table overflow-auto">
                <div class="search-box d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-center">
                  <div class="form-group w-100">
                    <i class="fa fa-search"></i>
                    <input
  value={search}
  defaultValue={""}
  ref={searchRef}
  type="text"
  placeholder="Search your invoices"
  class="form-control invoice-input"
  onChange={(e) => {
    setSearch(e.target.value);
    onSearchChangeHandler(e.target.value);
  }}
/>

                  </div>
                  <div class="sort text-nowrap">
                    <p>Sort by Payment :</p>
                    <ul>
                      <li className="d-light">
                        <a
                          href="#"
                          className={sortType === "unpaid" ? "border border-danger" : ""}
                          onClick={() => setSortType("unpaid")}
                        >
                          <i class="fa fa-circle text-danger"></i> Unpaid
                        </a>
                      </li>
                      <li className="d-dark ">
                        <a
                          href="#"
                          className={sortType === "unpaid" ? "border border-danger" : ""}
                          onClick={() => setSortType("unpaid")}
                          style={{ color: "white" }}
                        >
                          <i class="fa fa-circle text-danger"></i> Unpaid
                        </a>
                      </li>
                      <li className="d-dark">
                        <a
                          href="#"
                          className={sortType === "paid" ? "grn border border-success" : "grn"}
                          onClick={() => setSortType("paid")}
                          style={{ color: "white" }}
                        >
                          <i class="fa fa-circle "></i> Paid
                        </a>
                      </li>
                      <li className="d-light">
                        <a
                          href="#"
                          className={sortType === "paid" ? "grn border border-success" : "grn"}
                          onClick={() => setSortType("paid")}
                        >
                          <i class="fa fa-circle "></i> Paid
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <table>
                  <tr>
                    <th>INVOICE ID</th>
                    <th>PLAN</th>
                    <th>STATUS</th>
                    <th>TYPE</th>
                    <th>PAYMENT STATUS</th>
                    <th>AMOUNT</th>
                    <th>LEFT / TOTAL</th>
                    <th>PROCESSOR</th>
                    <th>DATE & TIME</th>
                    <th>ACTIONS</th>
                  </tr>

                  {allInvoices.map((invoice, index) => {
                    return (
                      <>
                        <tr>
                          <td>{invoice._id}</td>
                          <td>
                            {invoice.trial && "[Trial]"} {invoice.planName}
                          </td>
                          <td className="text-nowrap">
                            {invoice.topup === true && (
                              <>
                                {invoice.unresolvedStatus == null && invoice.paid && (
                                  <span className="bg-success bg-opacity-10" style={{ color: "var(--bs-green)" }}>
                                    Paid
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && !invoice.pending && (
                                  <span className="bg-danger bg-opacity-10" style={{ color: "var(--bs-danger)" }}>
                                    Unpaid
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && invoice.pending && (
                                  <span className="bg-info bg-opacity-10" style={{ color: "var(--bs-info)" }}>
                                    Pending
                                  </span>
                                )}
                                {!invoice.paid && !invoice.pending && invoice.unresolvedStatus != null && (
                                  <>
                                    <span
                                      className="bg-warning bg-opacity-10"
                                      style={{
                                        color: "var(--bs-warning)",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {invoice.unresolvedStatus.toLowerCase()}
                                    </span>
                                  </>
                                )}
                              </>
                            )}
                            {/* Renewal */}
                            {invoice.renew === true && (
                              <>
                                {invoice.unresolvedStatus == null && invoice.paid && (
                                  <span className="bg-success bg-opacity-10" style={{ color: "var(--bs-green)" }}>
                                    Renewed
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && !invoice.pending && (
                                  <span className="bg-danger bg-opacity-10" style={{ color: "var(--bs-danger)" }}>
                                    Unpaid
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && invoice.pending && (
                                  <span className="bg-info bg-opacity-10" style={{ color: "var(--bs-info)" }}>
                                    Pending
                                  </span>
                                )}
                                {!invoice.paid && !invoice.pending && invoice.unresolvedStatus != null && (
                                  <>
                                    <span
                                      className="bg-warning bg-opacity-10"
                                      style={{
                                        color: "var(--bs-warning)",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {invoice.unresolvedStatus.toLowerCase()}
                                    </span>
                                  </>
                                )}
                              </>
                            )}

                            {/* Subscription with renewal data */}
                            {invoice.renew === false &&
                              invoice.topup === false &&
                              Object.keys(invoice).includes("renewalDate") &&
                              invoice.renewalDate && (
                                <>
                                  {moment(invoice?.renewalDate).diff(moment().utc(), "seconds") > 0 ? (
                                    <span className="text-primary  bg-primary bg-opacity-10 text-nowrap">
                                      Ends in{" "}
                                      {moment.duration(moment(invoice?.renewalDate).diff(moment().utc(), "seconds") * 1000).humanize()}
                                    </span>
                                  ) : (
                                    <span className="bg-danger bg-opacity-10" style={{ color: "var(--bs-danger)" }}>
                                      Expired
                                    </span>
                                  )}
                                </>
                              )}

                            {/* Subscription without renewal data */}
                            {invoice.renew === false && invoice.topup === false && !Object.keys(invoice).includes("renewalDate") && (
                              <>
                                {invoice.unresolvedStatus == null && invoice.paid && (
                                  <span
                                    className="bg-danger bg-opacity-10"
                                    style={{
                                      color: "var(--bs-danger)",
                                    }}
                                  >
                                    Not Activated
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && !invoice.pending && (
                                  <span
                                    className="bg-danger bg-opacity-10"
                                    style={{
                                      color: "var(--bs-danger)",
                                    }}
                                  >
                                    Unpaid
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && invoice.pending && (
                                  <span className="bg-info bg-opacity-10" style={{ color: "var(--bs-info)" }}>
                                    Pending
                                  </span>
                                )}
                                {!invoice.paid && !invoice.pending && invoice.unresolvedStatus != null && (
                                  <>
                                    <span
                                      className="bg-warning bg-opacity-10"
                                      style={{
                                        color: "var(--bs-warning)",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {invoice.unresolvedStatus.toLowerCase()}
                                    </span>
                                  </>
                                )}
                              </>
                            )}
                          </td>
                          <td>{invoice.type}</td>
                          <td>
                            {invoice.unresolvedStatus == null && invoice.paid && (
                              <>
                                {/* <span className="legend-indicator bg-success" /> */}
                                <span className="bg-success bg-opacity-10 ">
                                  <i style={{ color: "rgba(0, 166, 17, 1)" }} class="fa fa-circle"></i>
                                  Paid
                                </span>
                              </>
                            )}
                            {invoice.unresolvedStatus == null && !invoice.paid && !invoice.pending && (
                              <>
                                {/* <span className="legend-indicator bg-danger" /> */}
                                <span className="bg-danger bg-opacity-10">
                                  <i class="fa fa-circle text-danger"></i>
                                  Unpaid
                                </span>
                              </>
                            )}
                            {invoice.unresolvedStatus == null && !invoice.paid && invoice.pending && (
                              <>
                                {/* <span className="legend-indicator bg-info" /> */}
                                <span className="bg-info bg-opacity-10">
                                  <i class="fa fa-circle text-info"></i>
                                  Pending
                                </span>
                              </>
                            )}
                            {!invoice.paid && !invoice.pending && invoice.unresolvedStatus != null && (
                              <>
                                {/* <span className="legend-indicator bg-warning" /> */}
                                <span
                                  className="bg-warning bg-opacity-10"
                                  style={{
                                    color: "var(--bs-warning)",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  <i class="fa fa-circle text-warning"></i>
                                  {invoice.unresolvedStatus.toLowerCase()}
                                </span>
                              </>
                            )}
                          </td>
                          <td className="fw-bolder">${invoice.price?.toFixed(2)}</td>
                          <td>
                          {invoice.topup === false &&
  (invoice.renew === true
    ? invoice.bandwidth
      ? `${invoice.bandwidthLeft} / ${Math.floor(invoice.bandwidth).toFixed(2)} GB`
      : invoice.type === "Residential" && invoice.bandwidth === 0
      ? "0 / 0 GB"
      : "Unlimited"
    : invoice.bandwidth !== 0
    ? `${invoice.bandwidthLeft} / ${(invoice.bandwidth).toFixed(2)} GB`
    : invoice.type === "Residential" && invoice.bandwidth === 0
    ? "0 / 0 GB"
    : "Unlimited")}

                            {invoice.topup === true && "-"}
                          </td>
                          <td>{invoice.paymentProcessor.toUpperCase()}</td>
                          <td>{formatTime(invoice.createdAt)}</td>
                          <td>
        <span onClick={() => handleModalOpen(invoice._id)} style={{ cursor: "pointer" }}>
  <img src="/assets/images/icons/pencill.svg" alt="icon" class="img-fluid" />
</span>


    </td>
                        </tr>
                      </>
                    );
                  })}
                </table>

                <Modal centered keyboard={false} show={showModal} onHide={handleModalClose} className="delete-modal">
                <Modal.Header closeButton>
  <div className="w-100">
    <Modal.Title className="fs-5">{selectedId} - Plan Control</Modal.Title>
    <div className="d-flex justify-content-start">
    <Button 
  variant="outline-primary" 
  className={`me-2 ${selectedInvoiceType === 'ipv6' ? 'active-button' : ''}`} 
  disabled={selectedInvoiceType !== 'ipv6'} 
  onClick={() => handleCategoryClick('IPv6')}
>
  IPv6
</Button>
<Button 
  variant="outline-primary" 
  className={`me-2 ${selectedInvoiceType === 'residential' ? 'active-button' : ''}`} 
  disabled={selectedInvoiceType !== 'residential'} 
  onClick={() => handleCategoryClick('Residential')}
>
  Residential
</Button>
<Button 
  variant="outline-primary" 
  className={`me-2 ${selectedInvoiceType === 'mobile' ? 'active-button' : ''}`} 
  disabled={selectedInvoiceType !== 'mobile'} 
  onClick={() => handleCategoryClick('Mobile')}
>
Mobile
</Button>
<Button 
  variant="outline-primary" 
  className={`me-2 ${selectedInvoiceType === 'isp' ? 'active-button' : ''}`} 
  disabled={selectedInvoiceType !== 'isp'} 
  onClick={() => handleCategoryClick('ISP')}
>
  ISP
</Button>
<Button 
  variant="outline-primary" 
  className={`${selectedInvoiceType === 'datacenter' ? 'active-button' : ''}`} 
  disabled={selectedInvoiceType !== 'datacenter'} 
  onClick={() => handleCategoryClick('Datacenter')}
>
  Datacenter
</Button>

    </div>
  </div>
</Modal.Header>

<Modal.Body className="m-4 text-center fs-6">
  {activeCategory === 'residential' && (
     <>
          <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
          {allInvoices.filter(invoice => invoice._id === selectedId).map((invoice, index) => (
            <p className="delete-modal" key={invoice._id} style={{ marginBottom: '20px' }}>
Bandwidth Left: {invoice?.bandwidthLeft}
</p>
))}
          </Form.Group>
          <Form.Group className="mb-3">
<Form.Check
        inline
        type="radio" 
        id="add" 
        name="action" 
        label="Add" 
        value="add" 
        defaultChecked
/>
<Form.Check
  inline
  type="radio" 
  id="remove" 
  name="action" 
  label="Remove" 
  value="del"
/>
</Form.Group>

          <Form.Group className="mb-3">
              <Form.Control ref={valueRef} className="modal-content" type="text" placeholder="GB value" />
          </Form.Group>
{notification === 'success' && <div className="alert alert-success">Successful!</div>}
  {notification === 'error' && <div className="alert alert-danger">{apiError}</div>}
{isLoading && (
<div className="w-100 text-center mt-3">
<div
  className="alert"
  role="alert"
  style={{
    backgroundColor: 'rgba(255, 165, 0, 0.2)',
    color: '#ffa500',
    border: '1px solid #ffa500',
    padding: '10px',
    borderRadius: '5px'
  }}
>
  Response waiting...
</div>
</div>
)}
          <Modal.Footer className="border-0">
              <div className="d-flex w-100 align-items-center justify-content-center">
      <Button variant="primary" type="submit" disabled={isLoading}>
        {isLoading ? 'Loading...' : 'Submit'}
      </Button>
              </div>
          </Modal.Footer>
      </Form>
      <Form onSubmit={handleSubmit3}>
  <Button type="submit" disabled={isLoading2}>
    {isLoading2 ? 'Loading...' : 'Bandwidth Update'}
  </Button>
</Form>
      </>
  )}
  


  {activeCategory === 'mobile' && (
     <>
          <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
          {allInvoices.filter(invoice => invoice._id === selectedId).map((invoice, index) => (
            <p className="delete-modal" key={invoice._id} style={{ marginBottom: '20px' }}>
Bandwidth Left: {invoice?.bandwidthLeft}
</p>
))}
          </Form.Group>
          <Form.Group className="mb-3">
<Form.Check
        inline
        type="radio" 
        id="add" 
        name="action" 
        label="Add" 
        value="add" 
        defaultChecked
/>
<Form.Check
  inline
  type="radio" 
  id="remove" 
  name="action" 
  label="Remove" 
  value="del"
/>
</Form.Group>

          <Form.Group className="mb-3">
              <Form.Control ref={valueRef} className="modal-content" type="text" placeholder="GB value" />
          </Form.Group>
{notification === 'success' && <div className="alert alert-success">Successful!</div>}
  {notification === 'error' && <div className="alert alert-danger">{apiError}</div>}
{isLoading && (
<div className="w-100 text-center mt-3">
<div
  className="alert"
  role="alert"
  style={{
    backgroundColor: 'rgba(255, 165, 0, 0.2)',
    color: '#ffa500',
    border: '1px solid #ffa500',
    padding: '10px',
    borderRadius: '5px'
  }}
>
  Response waiting...
</div>
</div>
)}
          <Modal.Footer className="border-0">
              <div className="d-flex w-100 align-items-center justify-content-center">
      <Button variant="primary" type="submit" disabled={isLoading}>
        {isLoading ? 'Loading...' : 'Submit'}
      </Button>
              </div>
          </Modal.Footer>
      </Form>
      </>
  )}

{activeCategory === 'ipv6' && (
  <>
    <div>
      <h4 style={{ fontWeight: "bold", fontSize: "larger" }}>Whitelist:</h4>
      {

        allInvoices.filter(invoice => invoice._id === selectedId)

          .map((invoice) => (

            invoice.authIPs && invoice.authIPs.length > 0
              ? invoice.authIPs.map((authIP, index) => (
                  <div key={index}>{authIP}</div>
                ))
              : <div>No Whitelist IP addresses have been added yet.</div>
          ))
      }
      <hr />
      <div>
      <Form onSubmit={handleSubmit2}>
      <Form.Group>
        <Form.Check 
          type="radio"
          label="Add"
          name="actionType"
          value="add"
          checked={actionType === 'add'}
          onChange={handleActionChange}
          inline
        />
        <Form.Check 
          type="radio"
          label="Remove"
          name="actionType"
          value="remove"
          checked={actionType === 'remove'}
          onChange={handleActionChange}
          inline
        />
      </Form.Group>
      {notification === 'success' && <div className="alert alert-success">Successful!</div>}
  {notification === 'error' && <div className="alert alert-danger">{apiError}</div>}
  <Form.Group>
  <Form.Control
    className="das-mod mb-3"
    type="text"
    placeholder="Enter IPv4 address"
    pattern="^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$"
    value={ipv4Address}
    onChange={handleIpv4Change}
    required
  />
  <div>
    <Button type="submit">Send</Button>
  </div>
</Form.Group>

    </Form>
      </div>
    </div>
  </>
)}



  {activeCategory === 'isp' && (
    <div>ISP Category Content</div>
  )}
  {activeCategory === 'datacenter' && (
  <>
  <div>
    <h4 style={{ fontWeight: "bold", fontSize: "larger" }}>Whitelist:</h4>
    {
      allInvoices.filter(invoice => invoice._id === selectedId)
        .map((invoice) => (
          invoice.authIPs && invoice.authIPs.length > 0
            ? invoice.authIPs.map((authIP, index) => (
                <div key={index}>{authIP}</div>
              ))
            : <div>No Whitelist IP addresses have been added yet.</div>
        ))
    }
    <hr />
    <div>
    <Form onSubmit={handleSubmit4}>
    <Form.Group>
      <Form.Check 
        type="radio"
        label="Add"
        name="actionType"
        value="add"
        checked={actionType === 'add'}
        onChange={handleActionChange}
        inline
      />
      <Form.Check 
        type="radio"
        label="Remove"
        name="actionType"
        value="remove"
        checked={actionType === 'remove'}
        onChange={handleActionChange}
        inline
      />
    </Form.Group>
    {notification === 'success' && <div className="alert alert-success">Successful!</div>}
{notification === 'error' && <div className="alert alert-danger">{apiError}</div>}
<Form.Group>
  <Form.Control
    className="das-mod mb-3"
    type="text"
    placeholder="Enter IPv4 address"
    pattern="^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$"
    value={ipv4Address}
    onChange={handleIpv4Change}
    required
  />
  <div>
    <Button type="submit">Send</Button>
  </div>
</Form.Group>

  </Form>
    </div>
  </div>
</>
  )}

  <Form onSubmit={handleSubmit}>
  </Form>
</Modal.Body>

    </Modal>


                {pager?.total > 1 && (
                  <div
                    className="container"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: 20,
                      border: "solid",
                      borderWidth: "0px",
                      borderTopWidth: "0.1px",
                      borderColor: "var(--bs-gray-300)",
                    }}
                  >
                    <nav>
                      <ul class="pagination" style={{ margin: 0 }}>
                        <li
                          class="page-item"
                          style={{
                            margin: "0px",
                            paddingTop: "2px",
                            borderColor: "var(--bs-gray-400)",
                            borderTopLeftRadius: 6,
                            borderBottomLeftRadius: 6,
                          }}
                          onClick={() => {
                            dispatch(
                              getAllcustomers({
                                page: pager.page <= 1 ? 1 : pager.page - 1,
                              })
                            );
                          }}
                        >
                          <a class="page-link  bg-transparent" href="#" aria-label="Previous">
                            <span aria-hidden="true" style={{ fontSize: "1.3rem" }}>
                              &laquo;
                            </span>
                          </a>
                        </li>

                        <li
                          class="page-item"
                          style={{
                            padding: 15,
                            display: "flex",
                            alignItems: "center",
                            margin: "0px",
                            borderColor: "var(--bs-gray-400)",
                          }}
                        >
                          {pager?.page} of {pager?.total}
                        </li>

                        <li
                          class="page-item"
                          style={{
                            margin: "0px",
                            paddingTop: "2px",
                            borderColor: "var(--bs-gray-400)",
                            borderTopRightRadius: 6,
                            borderBottomRightRadius: 6,
                          }}
                          onClick={() => {
                            dispatch(
                              getAllcustomers({
                                page: pager.page >= pager.total ? pager.total : pager.page + 1,
                              })
                            );
                          }}
                        >
                          <a class="page-link bg-transparent" href="#" aria-label="Next">
                            <span aria-hidden="true" style={{ fontSize: "1.3rem" }}>
                              &raquo;
                            </span>
                          </a>
                        </li>

                      </ul>
                      <input
  type="number"
  className="elegant-input"
  placeholder="Page number"
  min="1"
  step="1"
  style={{ marginRight: '1em', width: '67%' }}
  onChange={(e) => {
    const pageNumber = Math.floor(e.target.value);
    if (pageNumber >= 1 && pageNumber <= pager.total) {
      dispatch(getAllcustomers({ page: pageNumber }));
    }
  }}
/>


                    </nav>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Customers;
